import { useMap } from "react-leaflet";
import { useParams } from "react-router";
import { CaseBufferOnMap } from "../on-map/CaseBufferOnMap";

interface Props {
  opacity: number;
  pane: string;
}
export function CaseBufferOverlayer(props: Props) {
  const map = useMap();
  const { caseId } = useParams<{ caseId: string }>();

  if (!map) {
    console.warn("Can't render CaseBuffer overlayer when not inside <MapContainer />");
    return null;
  }

  if (!caseId) {
    console.warn("Can't render CaseBuffer without a caseId");
    return null;
  }

  return render();

  function render() {
    return <CaseBufferOnMap map={map} caseId={caseId} opacity={props.opacity} pane={props.pane} />;
  }
}
